import { CircleX } from "lucide-react";
import React from "react";
import { Modal, ModalProps } from "react-bootstrap";
import RightBubble from "./svgr/RightModalBubble";
import LeftBubble from "./svgr/LeftModalBubble";
import WaitingMessage from "./WaitingMessage";
import DoneMessage from "./DoneMessage";

type LoadingModalProps = ModalProps & {
    viewType: string;
  };
  

function LoadingModal({ viewType, onHide, ...props }: LoadingModalProps) {

    const contentToShow = () => {
        switch (viewType) {
            case "Waiting":
                return <WaitingMessage />
            case "Done":
                return <DoneMessage />
            default:
                break;
        }
    }


  return (
    <Modal
      {...props}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
        <Modal.Body className="loading-modal-body">
            <div className="d-flex justify-content-end w-100 position-relative z-3 cursor-pointer" onClick={onHide}>
                <CircleX style={{cursor: "pointer"}} />
            </div>
            <div className="bubble--one">
                <RightBubble />
            </div>
            <div className="position-relative z-3 mt-2">
                {contentToShow()}
            </div>
            <div className="bubble--two">
                <LeftBubble />
            </div>
        </Modal.Body>
    </Modal>
  );
}

export default LoadingModal;
